module.exports = __webpack_public_path__ + "hu.df9b28299d8391897259.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/hu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/hu.svg
// module chunks = styles